/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Bangup from '../Playbar/Bangup';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class BangupEffect extends Effect {
    @property({ override: true, visible: false })
    protected reference: any;

    @property(InjectableComponent)
    protected bangupRef: InjectableComponent<Bangup> = new InjectableComponent();

    @property
    protected cumulative: boolean = true;

    protected setContexts(): void
    {
        super.setContexts();

        this.bangupRef.SetContext(Bangup);
    }

    protected trigger = (): void =>
    {
        this.bangupRef.WithValue(bangup => bangup.IsCumulative = this.cumulative);
        this.complete();
    }
}
